import { useUserContext } from "./useUserContext";
import { createAxiosApi } from "../Helpers/axiosApiHelper";
import {
	useState,
	useEffect
} from "react";

export function useUserService(config) {
	const user = useUserContext(config);
	const [userService, setUserService] = useState(() => {
		return createUserService(user, config);
	});

	useEffect(() => {
		setUserService(createUserService(user, config));
	}, [user.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

	return userService;
}

function createUserService(user, config) {
	const api = createAxiosApi("", user, config);

	function getAllUsers(handleResponse, handleError) {
		api.get("Users/")
			.then(handleResponse)
			.catch(handleError);
	}

	function getUserById(appUserId, handleResponse, handleError) {
		api.get(`Users/${appUserId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function createUser(appUser, handleResponse, handleError) {
		api.post("Users/", appUser)
			.then(handleResponse)
			.catch(handleError);
	}

	function updateUser(appUserId, appUser, handleResponse, handleError) {
		api.put(`Users/${appUserId}`, appUser)
			.then(handleResponse)
			.catch(handleError);
	}

	function deleteUser(appUserId, handleResponse, handleError) {
		api.delete(`Users/${appUserId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	return {
		getAllUsers,
		getUserById,
		createUser,
		updateUser,
		deleteUser
	};
}
